module.exports = __webpack_public_path__ + "static/very_card-a6ac5fb583d786ccfe49afe30636dbea.png";